const rules = {
    PAYGREEN: {
        static: ['routes:admin', 'sidebar:admin', 'routes:shop'],
    },
    ADMIN: {
        static: ['routes:shop'],
    },
    USER: {
        static: ['routes:shop'],
    },
    RECETTE: {
        static: ['routes:dev'],
    },
    SANDBOX: {
        static: ['routes:sandbox'],
    },
    PRODUCTION: {
        static: ['routes:prod'],
    },
};
export default rules;
